import { GetB2bOperationErOneResponse } from '@Common/types/bo/b2b/operations_er';

export const b2bOperationsErTranslations = {
  fields: {
    id: 'Transaction ID',
    operation_nature: 'Nature',
    operation_type: 'Type',
    amount_gross: 'Total gross amount',
    amount_net: 'Total net amount',
    products: 'Equipment',
    employee_count: 'Number of eligible employees',
    reference_period_start_date: 'Reference period',
    reference_period_end_date: 'Reference period end date',
    from_reference_period_start_date: 'Reference period start date',
    to_reference_period_end_date: 'Reference period end date',
    processing_date: 'Processing date',
    from_processing_date: 'Processing date after',
    to_processing_date: 'Processing date before',
  } satisfies Record<
    | keyof GetB2bOperationErOneResponse
    | 'from_reference_period_start_date'
    | 'to_reference_period_end_date'
    | 'from_processing_date'
    | 'to_processing_date',
    string
  >,
  choices: {
    nature: {
      MV: 'Movement',
      AN: 'Cancellation',
      IM: 'Cancellation due to unpaid',
    } satisfies Record<GetB2bOperationErOneResponse['operation_nature'], string>,

    type: {
      ABONDEMENT: 'Individual Employer Contribution',
      ABONDEMENT_COLL: 'Collective Employer Contribution',
      ABONDEMENT_DES: 'Divestment Employer Contribution',
      ABONDEMENT_INV: 'Investment Employer Contribution',
      AFF_ABONDE: 'Allocation Employer Contribution',
      AFF_COT: 'Contribution Allocation',
      AFF_COT_E: 'Contribution Allocation (E)',
      AFF_COT_EXO: 'Exempt Contribution Allocation',
      AFF_COT_RATT: 'Contribution Allocation (RATT)',
      AFF_COT_RATT_E: 'Contribution Allocation (RATT_E)',
      AFF_COT_RATT_S: 'Contribution Allocation (RATT_S)',
      AFF_COT_S: 'Employee Contribution Allocation',
      AFF_INTERESS: 'Allocation Profit-Sharing',
      AFF_PARTICIP: 'Allocation Participation',
      AFF_PPV: 'Value-Sharing Premium Allocation',
      AFF_PPVE: 'PPVE Allocation',
      AFF_VERS_CET: 'Allocation CET',
      ARB: 'Rebalancing',
      ARB_ATT: 'Pending Rebalancing',
      ARB_ATT_DES: 'Outgoing Pending Rebalancing',
      ARB_ATT_EST_DES: 'Estimated Outgoing Pending Rebalancing',
      ARB_ATT_EST_INV: 'Estimated Incoming Pending Rebalancing',
      ARB_ATT_INV: 'Incoming Pending Rebalancing',
      ARB_AU_DES: 'Automatic Outgoing Rebalancing',
      ARB_AU_INV: 'Automatic Incoming Rebalancing',
      ARB_CATT_DES: 'Outgoing Pending Account Rebalancing',
      ARB_CATT_INV: 'Incoming Pending Account Rebalancing',
      ARB_CO: 'Collective Rebalancing',
      ARB_CO_DES: 'Outgoing Collective Rebalancing',
      ARB_CO_INV: 'Incoming Collective Rebalancing',
      ARB_COM: 'Commercial Rebalancing',
      ARB_COM_DES: 'Outgoing Commercial Rebalancing',
      ARB_COM_INV: 'Incoming Commercial Rebalancing',
      ARB_DES: 'Outgoing Rebalancing',
      ARB_INV: 'Incoming Rebalancing',
      ARB_PSAP_DES: 'Outgoing PSAP Rebalancing',
      ARB_PSAP_INV: 'Incoming PSAP Rebalancing',
      ARB_REBAL_DES: 'ARB_REBAL_DES',
      ARB_REBAL_INV: 'ARB_REBAL_INV',
      ARB_SECU_DES: 'Outgoing Security Rebalancing',
      ARB_SECU_INV: 'Incoming Security Rebalancing',
      AVANCE_FDS_RLMT: 'Working Capital Advance',
      CC_REVALO: 'Capital Constituting Revaluations',
      CC_REVALO_39: 'Revaluation CC',
      COM_FDS_COLL: 'Commission on Collective Fund A39',
      COTI_ANTIC: 'Advance Contribution',
      COTI_EXCEP: 'Exceptional Contribution',
      COTI_RATT: 'Backdated Contribution',
      COTI_RATT_E: 'Backdated Contribution (E)',
      COTI_RATT_S: 'Backdated Contribution (S)',
      COTI_REGUL: 'Regularization Contribution',
      COTIS: 'Contribution',
      COTIS_DES: 'Contribution Divestment',
      COTIS_E: 'Employer Contribution',
      COTIS_ESTIM: 'Estimated Contribution',
      COTIS_ESTIM_N: 'Estimated Contribution (N)',
      COTIS_EXO: 'Tax-Exempt Contribution Paid by Insurer',
      COTIS_EXO_INV: 'Tax-Exempt Contribution Investment',
      COTIS_INV: 'Contribution Investment',
      COTIS_S: 'Employee Contribution',
      D_TR_E_C_E: 'Incoming External Collective Transfer Request',
      D_TR_E_C_E_DES: 'Incoming External Collective Transfer Request - Divestment',
      D_TR_E_C_E_INV: 'Incoming External Collective Transfer Request - Investment',
      D_TR_E_C_I: 'Incoming Internal Collective Transfer Request',
      D_TR_E_C_I_DES: 'Incoming Internal Collective Transfer Request - Divestment',
      D_TR_E_C_I_INV: 'Incoming Internal Collective Transfer Request - Investment',
      D_TR_S_C_E: 'Outgoing External Collective Transfer Request',
      D_TR_S_C_I: 'Outgoing Internal Collective Transfer Request',
      DC_ACTIF_39: 'Active Member Death (39)',
      DECES_ACTIF: 'Active Member Death',
      DC_PREST: 'Death Benefit',
      DC_REGL: 'Death Payment',
      FISCALITE: 'Taxation',
      FR_CPT_ENT: 'Company Contract Management Fees',
      FR_CPT_SOUS: 'Employee Contract Management Fees',
      FR_DC_EU: 'Euro Death Charges',
      FR_DC_UC: 'UC Death Charges',
      FR_ENC_MIN: 'Exit Charges',
      FR_EU: 'Euro Management Fees',
      FR_EU_COMPL: 'Additional Outstandings Charges',
      FR_EU_REDUC: 'Exit Management Fees',
      FR_FCL: 'IFC/IL Charges',
      FR_GAR_PLAN: 'Floor Guarantee Charges',
      FR_PRIME: '100% Charge Premium',
      FR_REDUC: 'Reduction Charges',
      FR_RENTE: 'Annuity Service Charges',
      FR_TABLE_EU: 'Euro Table Charges',
      FR_TABLE_UC: 'UC Table Charges',
      FR_UC: 'UC Management Charges',
      FR_UC_COMPL: 'Margin, charges on certain PCLOG contracts',
      INTERESS_DES: 'Divestment Profit-Sharing',
      INTERESS_EXCEPT: 'Exceptional Profit-Sharing',
      INTERESS_INV: 'Investment Profit-Sharing',
      INTERESS_REGUL: 'Profit-Sharing Regularization',
      INTERESSEMENT: 'Profit-Sharing',
      NANTISSEMENT: 'Pledge/Lien',
      OST_DDC: 'Coupon Detachment',
      OST_FA_DES: 'Merger / Acquisition Outgoing',
      OST_FA_INV: 'Merger / Acquisition Incoming',
      PAR: 'Profit Sharing (PAR)',
      PARTICIP_DES: 'Divestment Participation',
      PARTICIP_EXCEPT: 'Exceptional Participation',
      PARTICIP_INV: 'Investment Participation',
      PARTICIP_REGUL: 'Participation Regularization',
      PARTICIPATION: 'Participation',
      PB: 'Profit Sharing (PB)',
      PB_FDS_RENTE: 'Annuity Account Profit Sharing',
      PB_GAR_CAPITAL: 'Capital Guarantee',
      PERT_TECH_39: 'Technical Losses',
      PM_AJUST: 'Outstanding Adjustment',
      PPV: 'Value Sharing Premium',
      PPV_DES: 'Divestment PPV',
      PPV_E: 'Company Value Sharing Premium',
      PPV_INV: 'Investment PPV',
      PPVE_DES: 'Divestment PPVE',
      PPVE_INV: 'Investment PPVE',
      PRA: 'Profit Sharing (Anticipated)',
      PREST_39: 'Article 39 Benefit',
      PREST_CC: 'Capital Constituting Revaluation Fund Benefit',
      PREST_FILLON: 'Fillon Benefit',
      PREST_IFC: 'IFC Benefit',
      PREST_IL: 'IL Benefit',
      PRLV_FISC: 'Tax Withholding',
      PRLV_FISC_OBLIG: 'Mandatory Tax Withholding',
      PRLV_SOC: 'Social Security Withholding',
      PRST_CHARGE_SOC: 'Social Charges Benefit',
      PRST_EXECEPTION: 'Exceptional Benefit',
      PSAP: 'Provision for Claims Outstanding',
      PSAP_EA: 'EA Before PSAP',
      PSAP_PREST: 'Compl. Benefit',
      PVP: 'Programmed Payment Withdrawal',
      RB_PRLV_SOC: 'Social Withholding Refund',
      RBT_CARENCE_39: 'Waiting Period Refund (39)',
      RBT_CARENCE: 'Waiting Period Refund',
      REG_ACTIF: 'Asset Regularization',
      REG_PASSIF: 'Liability Regularization',
      REGLE_COM_ENC: 'Commission Settlement on Outstandings',
      REGLE_COM_MVT: 'Commission Settlement on Movements',
      REMB_FDS_RLMT: 'Working Capital Refund',
      REX: 'Exceptional Redemption',
      RP: 'Partial Redemption',
      RPP: 'Programmed Partial Redemption',
      RT: 'Total Redemption',
      SOR_CAPITAL: 'Capital Exit',
      SOR_CAPITAL_ENT: 'Company Capital Exit',
      SOR_RENTE: 'Annuity Exit',
      SOR_RENTE_ENT: 'Company Annuity Exit',
      SOR_RENTE_UNIQ: 'Single Annuity Exit',
      T_PEP: 'Profit and Loss',
      TMG: 'Revaluation Share Linked to Minimum Guaranteed Rate',
      TR_E_C_I_STOCK: 'Incoming Internal Collective Stock Transfer',
      TR_ENT_C_E: 'Incoming External Collective Transfer',
      TR_ENT_C_I: 'Incoming Internal Collective Transfer',
      TR_ENT_C_RENTE: 'Incoming Collective Transfer of Capital Constituting Annuities',
      TR_ENT_E: 'Incoming External Transfer',
      TR_ENT_I: 'Incoming Internal Transfer',
      TR_ENT_I_STOCK: 'Incoming Individual Stock Transfer',
      TR_ENTR_EXC_REV: 'A39 Revaluation Fund Excess',
      TR_ENTR_REVALO: 'PM Entry from A39 Revaluation Fund',
      TR_SOR: 'Outgoing Transfer',
      TR_SOR_C_E: 'Outgoing External Collective Transfer',
      TR_SOR_C_I: 'Outgoing Internal Collective Transfer',
      TR_SOR_C_P_E:
        'Outgoing External Partial Collective Transfer for contracts with employee view',
      TR_SOR_C_P_I:
        'Outgoing Internal Partial Collective Transfer for contracts with employee view',
      TR_SOR_E: 'Outgoing External Transfer',
      TR_SOR_I: 'Outgoing Internal Transfer',
      TR_SOR_PAR_C_E:
        'Outgoing External Partial Collective Transfer for contracts without employee view',
      TR_SOR_PAR_C_I:
        'Outgoing Internal Partial Collective Transfer for contracts without employee view',
      TR_SORT_REVALO: 'PM Exit to A39 Revaluation Fund',
      TR_TECHNIQUE: 'Technical Transfer',
      V1: 'Initial Payment',
      VERS_CET: 'CET Payment',
      VERS_CET_DES: 'Divestment CET Payment',
      VERS_CET_INV: 'Investment CET Payment',
      VERS_CET_REGUL: 'CET Payment Regularization',
      VL: 'Free Payment',
      VL_ENT: 'Company Free Payment',
      VL_GRA: 'Free of charge Payment',
      VP: 'Programmed Payment',
      VP_ENT: 'Company Programmed Payment',
    } satisfies Record<GetB2bOperationErOneResponse['operation_type'], string>,
  },
  tabs: {
    in_progress: 'In progress',
    history: 'History',
  },
};
